import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomReuseStrategy } from './reuse-strategy.route';
import { CustomTranslateHttpLoader } from './shared/CustomTranslateHttpLoader';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { UmsInterceptor } from './shared/interceptors/ums.interceptor';
import { GlobalErrorHandler } from './shared/modules/errors/handler/global-error-handler';
import { AppLoadService } from './shared/services/app-load/app.load.service';
import { AuthService } from './shared/services/auth/auth.service';
import { ConfigService } from './shared/services/config/config.service';
import { ExitConfirmationService } from './shared/services/exit-confirmation/exit-confirmation.service';
import { SessionService } from './shared/services/session/session.service';
import { TizenService } from './shared/services/tizen/tizen.service';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateHttpLoader,
        deps: [HttpClient, ConfigService],
      },
    }),
  ],
  providers: [
    AuthService,
    AppLoadService,
    SessionService,
    TizenService,
    ExitConfirmationService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: MatDialogRef,
      useValue: {},
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (appConfigService: AppLoadService) => {
        return () => {
          //Make sure to return a promise!
          return appConfigService.getSettings();
        };
      },
      deps: [AppLoadService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }, // needs to be before UmsInterceptor
    { provide: HTTP_INTERCEPTORS, useClass: UmsInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    { provide: Window, useValue: window },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
